export class BookingEntity {
    constructor() {
    }

    public booking_id: any = null;
    public cliente_id: any = null;
    public nave_id: any = null;
    public viaje_id: any = null;
    public producto_id: any = null;
    public operador_id: any = null;
    public booking_number: any = null;
    public booking_eta: any = null;
    public booking_consignatario: any = null;
    public booking_puerto: any = null;
    public booking_destino: any = null;
    public booking_nave: any = null;
    public booking_viaje: any = null;
    public booking_tipocontenedor: any = null;
    public booking_numerocontenedores: any = null;
    public booking_equipamentsize: any = null;
    public booking_estado: any = null;
    public linea_id: any = null;
    public coordinador_id: any = null;
    public booking_ordenservicioporcontenedor: any = null;
    public booking_ficherobooking: any = null;
    public booking_ficherobookingfecha: any = null;
    public booking_ficherotemperatura: any = null;
    public booking_ficherotemperaturafecha: any = null;
    public booking_ficheroinstrucciones: any = null;
    public booking_ficheroinstruccionesfecha: any = null;
    public booking_tipoembarque: any = null;
    public booking_codigo: any = null;
    public booking_esposicionamiento: any = null;
    public booking_fecharegistro: any = null;
    public booking_adicionalproducto: any = null;
    public booking_nrosemana: any = null;
    public booking_cambionrosemana: any = null;
    public booking_fechacarga: any = null;
    public booking_terminalembarque: any = null;
    public booking_terminalembarqueid: any = null;
    public booking_fechaprogramacarguio: any = null;
    public booking_escargasuelta: any = null;
    public booking_cancelado: any = null;
    public broker_id: any = null;
    public booking_tarifa: any = null;
    public booking_verconsolidado: any = null;
    public booking_esalcontado: any = null;
    public booking_obsop: any = null;
    public booking_obsopadicional: any = null;
    public booking_obsfact: any = null;
    public booking_obsfactadicional: any = null;
    public booking_espreregistro: any = null;
    public booking_generomatriz: any = null;
    public booking_bl: any = null;
    public booking_importado: any = null;
    public booking_pagoterminal: any = null;
    public booking_tipo: any = null;
    public booking_ficherofactura: any = null;
    public booking_ficherofacturafecha: any = null;
    public booking_ficherogarea: any = null;
    public booking_ficherogareafecha: any = null;
    public booking_ficheroanticipo: any = null;
    public booking_ficheroanticipofecha: any = null;
    public booking_usuarioanticipo: any = null;
    public booking_codigocampania: any = null;
    public booking_referencia: any = null;
    public booking_temperatura: any = null;
    public booking_sintarifa: any = null;
    public booking_descargafact: any = null;
    public booking_espendiente: any = null;
    public booking_stvgm: any = null;
    public booking_stdf: any = null;
    public booking_stmatriz: any = null;
    public booking_stbl: any = null;
    public booking_fwdcliente: any = null;
    public booking_fwdagente: any = null;
    public agente_id: any = null;
    public booking_fechadf: any = null;
    public booking_fechacanal: any = null;
    public booking_obs: any = null;
    public booking_fechaobs: any = null;
    public booking_userobs: any = null;
    public booking_hasobs: any = null;
    public booking_observado: any = null;
    public booking_isconsolidada: any = null;
    public booking_padreid: any = null;
    public consignatario_id: any = null;
    public booking_user: any = null;
    public booking_observacion: any = null;

    public producto: any = null;
    public linea: any = null;
    public nave: any = null;
    public viaje: any = null;
    public isPending: any = null;


}
